/* eslint-disable react/prop-types */

import moment from "moment";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import MDBadge from "components/MDBadge";
import WifiOffIcon from "@mui/icons-material/WifiOff";

export default function tableConfig() {
  return {
    columns: [
      { Header: "Clock Name", accessor: "description", align: "left" },
      { Header: "Serial Number", accessor: "macAddress", align: "left" },
      { Header: "Android Id", accessor: "deviceMacAddress", align: "left" },
      { Header: "Location", accessor: "location", align: "center" },
      { Header: "Timezone", accessor: "timezone", align: "center" },
      { Header: "SubAccount", accessor: "project", align: "center" },
      { Header: "Status", accessor: "status", align: "center" },
      // { Header: "Url", accessor: "url", align: "center" },
      { Header: "Created At", accessor: "createdAt", align: "center" },
      { Header: "Actions", accessor: "action", align: "right" },
    ],
    getRows: (data, locationData, timezoneData, setDeviceToEdit, setDeviceToDisconnect) =>
      data.map((d) => ({
        description: d.description,
        macAddress: d.macAddress,
        deviceMacAddress: d.deviceMacAddress,
        location: locationData[d.location]?.name || "",
        timezone: timezoneData[d.timezone]?.text || "",
        project: d.project,
        status: (
          <MDBox ml={-1}>
            <MDBadge
              badgeContent={d.status === "1" ? "Active" : "Inactivte"}
              color={d.status === "1" ? "success" : "error"}
              variant="gradient"
              size="sm"
            />
          </MDBox>
        ),
        createdAt: d.createdAt ? moment(d.createdAt).locale("en").format("LLL") : "Never",
        // url: (
        //   <>
        //     <a
        //       href={`${window.location.origin}/device-clock-in/${d.id}`}
        //       target="_blank"
        //       rel="noreferrer"
        //     >
        //       Link
        //     </a>
        //   </>
        // ),
        action: (
          <>
            {d.connected && (
              <IconButton
                size="small"
                aria-label="Disconnect"
                color="inherit"
                onClick={() => setDeviceToDisconnect(d)}
              >
                <WifiOffIcon fontSize="small" />
              </IconButton>
            )}
            <IconButton
              size="small"
              aria-label="edit"
              color="inherit"
              onClick={() => setDeviceToEdit(d)}
            >
              <Icon fontSize="small">edit</Icon>
            </IconButton>
          </>
        ),
      })),
  };
}
